<template>
    <div>
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <h1 class="text-uppercase text-black  display-header home-text mx-2 text-center">Contact</h1>
            </div>

        </div>

        <div class="bg-dark w-100 mb-3 mt-5" style="height: 2px;"></div>
        <div class="container-fluid open-sans">
            <div class="row py-5">
                <div class="col-12 col-md-6 col-lg-4 offset-lg-1">
                    <h2 class="contact-section-heading contact-section-heading--blue oswald-bold pb-2">Get in Touch</h2>

                    <div class="contact-card contact-card--blue mt-3">
                        <p class="contact-label">General Questions</p>
                        <a href="mailto:info@atlasimprov.com" class="contact-link">info@atlasimprov.com</a>
                    </div>
                    <div class="contact-card contact-card--magenta">
                        <p class="contact-label">Classes</p>
                        <a href="mailto:edu@atlasimprov.com" class="contact-link">edu@atlasimprov.com</a>
                    </div>

                    <h2 class="contact-section-heading contact-section-heading--red oswald-bold pb-2 pt-4">Location &amp; Parking</h2>

                    <div class="contact-card contact-card--red mt-3">
                        <p class="contact-label">Address</p>
                        <a href="https://www.google.com/maps?q=609+E+Washington+Ave+Madison,+WI+53703"
                            class="location-link oswald-bold fs-5 d-block" target="_blank" rel="noopener">609 E. Washington Ave.<br>Madison, WI 53703</a>
                    </div>
                    <div class="contact-card contact-card--green">
                        <p class="contact-label">Parking</p>
                        <p class="mb-0">MGE good neighbor lots at 640 E. Main Street and 1600 Railroad Street. Additional parking at 665 E. Washington Ave., adjacent to the Brass Ring. Street parking also available on Blount and Main Streets.</p>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-5 offset-lg-1">

                    <img :src="`${$API_ASSETS}9575146c-0de7-462b-bcde-040e373996b1.png`" class="img-fluid w-100" />
                    <div class="pt-2 text-start">
                      <a href="https://www.google.com/maps?q=609+E+Washington+Ave+Madison,+WI+53703" class="contact-link text-decoration-underline" target="_blank" rel="noopener">Click here for Directions</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid position-relative pt-2 site-black-bg overflow-hidden" ref="pressSection">
            <!-- Background Image -->
            <div class="position-relative">
                <!-- Overlayed Text Container -->
                <div class="position-absolute w-100 text-overlay" style="top: 20%; left: 0; padding-left: 10%; z-index: 2;">
                    <div class="col-lg-4 text-white text-start" v-if="press">
                        <div class="press-grid">
                          <div class="col-span-2">
                            <div class="text-uppercase display-4 oswald-bold r">Press</div>
                            <div class="py-2 pb-5">Writing a story about us? Need a picture or logo? Please feel free
                              to download from our selection below. For interviews us at info@atlasimprov.com.
                            </div>
                          </div>
                          <div>
                            <div class="text-uppercase display-5 oswald-bold ">Company Logo</div>
                            <div class="contact-link"><a :href="assetUrl(press.pdf_logo.id)">pdf</a></div>
                            <div class="contact-link"><a :href="assetUrl(press.image_logo_small.id)">png(small)</a></div>
                            <div class="contact-link"><a :href="assetUrl(press.image_logo_medium.id)">png(medium)</a></div>
                            <div class="contact-link pb-5"><a :href="assetUrl(press.image_logo_large.id)">png(large)</a></div>
                          </div>
                          <div>
                            <div class="text-uppercase display-5 oswald-bold">Company Pictures</div>
                            <div class="contact-link"><a :href="assetUrl(press.company_photo_1.id)">image 1</a></div>
                            <div class="contact-link pb-5"><a :href="assetUrl(press.company_photo_2.id)">image 2</a></div>
                          </div>
                          <div>
                            <div class="text-uppercase display-5 oswald-bold">Press Releases</div>
                            <div class="contact-link"><a :href="assetUrl(press.cut_release.id)">The Cut</a></div>
                            <div class="contact-link"><a :href="assetUrl(press.endurance_release.id)">The Endurance Improv Festival</a></div>
                          </div>
                        </div>
                    </div>
                </div>
                <picture>
                  <source srcset="@/assets/Press-mobile-bg.png" media="(max-width: 767px)" />
                  <img :src="require('@/assets/Press-bg.png')"
                    class="img-fluid w-100 press-img"
                    :class="{ 'press-img-visible': pressVisible }" />
                </picture>
            </div>
        </div>


        <Footer />

    </div>



</template>

<script>
import axios from 'axios';
import Footer from '../components/Footer.vue';


export default {
  name: 'Contact',
  components: {
    Footer,
  },
  data() {
    return {
      press: null,
      pressVisible: false,
    };
  },
  mounted() {
    this._pressObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.pressVisible = true;
        this._pressObserver.disconnect();
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    this._pressObserver.observe(this.$refs.pressSection);
  },
  beforeUnmount() {
    if (this._pressObserver) this._pressObserver.disconnect();
  },
  methods: {
    async fetchPressAssets() {
      try {
        const response = await axios.post(this.$API_GRAPHQL, {
          query: `
            query {
              press {
                pdf_logo { id }
                image_logo_large { id }
                image_logo_medium { id }
                image_logo_small { id }
                cut_release { id }
                endurance_release { id }
                company_photo_2{id}
                company_photo_1{id}
              }
            }
          `
        }, {
          headers: {
            Authorization: `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
            'Content-Type': 'application/json'
          }
        });

        this.press = response.data.data.press;
      } catch (error) {
        console.error('Error fetching press assets:', error);
      }
    },
    assetUrl(id) {
      // ?download makes Directus send Content-Disposition: attachment so the
      // browser downloads the file instead of opening it inline (works cross-origin).
      return `${this.$API_ASSETS}${id}?download`;
    }
  },
  created() {
    this.fetchPressAssets();
  }
};
</script>

<style scoped>
.contact-section-heading {
  font-size: 2.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding-bottom: 0.5rem;
  display: block;
  text-align: left;
}
@media (max-width: 767px) {
  .contact-section-heading {
    text-align: center;
  }
}
.contact-section-heading--blue    { border-bottom: 2px solid var(--atlas-blue); }
.contact-section-heading--red     { border-bottom: 2px solid var(--atlas-red); }
.contact-section-heading--magenta { border-bottom: 2px solid var(--atlas-magenta); }
.contact-section-heading--green   { border-bottom: 2px solid var(--atlas-green); }

.contact-card {
  padding: 0 0 0.75rem 1rem;
  margin-bottom: 1.25rem;
}
.contact-card--blue    { border-left: 3px solid var(--atlas-blue); }
.contact-card--red     { border-left: 3px solid var(--atlas-red); }
.contact-card--magenta { border-left: 3px solid var(--atlas-magenta); }
.contact-card--green   { border-left: 3px solid var(--atlas-green); }

.contact-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #888;
  margin-bottom: 0.25rem;
}

.press-img {
  transform: translateX(80px);
  opacity: 0;
  transition: transform 1.5s ease, opacity 1.5s ease;
}

.press-img.press-img-visible {
  transform: translateX(0);
  opacity: 1;
}

@media (max-width: 1024px) {
  .text-overlay {
    position: static !important;
    padding: 2rem 1rem;
  }

  .press-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  .press-grid .col-span-2 {
    grid-column: span 2;
  }
}
</style>
